<template>
    <div :class='b({fixed})'>
        {{ info }}
    </div>
</template>

<script>
import create from 'omui/components/utils/create'
export default create({
  name: 'bottom-placeholder',

  props: {
    fixed: {
      type: Boolean,
      default: false
    },
    info: {
      type: String,
      default: '- 米社科技 -'
    }
  }
})
</script>



// WEBPACK FOOTER //
// src/plugins/jscom/omui/combines/bottom-placeholder/index.vue